import axios from 'axios';
import Rails from '@rails/ujs';

class OnsenAiRecommendUi {
  baseUri = '/onsen-concierge/onsen_ai.js';
  formEl = document.querySelector('[data-mp-role="onsen-ai-form"]');
  submitEl = this.formEl.querySelector('[data-mp-role="onsen-ai-submit-btn"]');
  importantCkEls = this.formEl.querySelectorAll('[name="ai_step_1"]');
  feeling1SliderEl = this.formEl.querySelector('[data-mp-role="onsen-ai-feeling1-slider"]');
  feeling2SliderEl = this.formEl.querySelector('[data-mp-role="onsen-ai-feeling2-slider"]');
  waypointRadioEls = this.formEl.querySelectorAll('[name="ai_step_3"]');
  scrollPositionEl = document.getElementById('onsen_ai_result');

  constructor(opts = {}) {
    if (opts.baseUri) this.baseUri = opts.baseUri;

    this.submitEl.addEventListener('click', (e) => {
      // [note to ooshima-san] 本来の挙動 (aタグの遷移)を行いたいのであればこの行を削除
      e.preventDefault();

      this.fetch();
    });
  }

  fetch() {
    const requestUri = this.baseUri + this.getQueryStrings();
    axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
    axios.interceptors.request.use((config) => ({
      ...config,
      headers: { ...config.headers, 'X-CSRF-Token': Rails.csrfToken() },
    }));
    axios
      .get(requestUri)
      .then((res) => {
        // [note] 結果タグ(html)を表示に追加する
        const result = document.getElementById('onsen_ai_result');
        result.innerHTML = res.data;

        // 結果部分にスクロール
        this.scrollPositionEl.scrollIntoView(true);
      })
      .catch((err) => {
        console.log(err.response); // eslint-disable-line no-console
        return null;
      });
  }

  getQueryStrings() {
    const crImportantCkEl = Array.from(this.importantCkEls).find((el) => el.checked === true);
    const crWaypointRadioEl = Array.from(this.waypointRadioEls).find((el) => el.checked === true);

    const choiceVal = crImportantCkEl.value;
    const feeling1Val = this.feeling1SliderEl.value;
    const feeling2Val = this.feeling2SliderEl.value;
    const placeVal = crWaypointRadioEl ? crWaypointRadioEl.value : null;

    let str = '';
    str += `?choice=${choiceVal}`;
    str += `&feeling1=${feeling1Val}`;
    str += `&feeling2=${feeling2Val}`;
    if (placeVal !== null) str += `&place=${placeVal}`;

    return str;
  }
}

const onsenAiForm = document.querySelector('[data-mp-role="onsen-ai-form"]');

if (onsenAiForm !== null) {
  new OnsenAiRecommendUi({ baseUri: '/onsen-concierge/onsen_ai.js' });
}
